module.exports = __webpack_public_path__ + "img/ball_twitterscan.c80fcbcd.png";